module.exports = __webpack_public_path__ + "img/hyu_main2.d8a2fdb0.jpg";